
    import './styles.scoped.css';
    export default {
  "breadcrumbs-own": "awsui_breadcrumbs-own_ete58_yonx9_5",
  "breadcrumbs-discovered": "awsui_breadcrumbs-discovered_ete58_yonx9_5"
};
  